<template>
    <div v-if="additionals.salaVacinacaoLogada">
        <rkm-area no-margin-top title="Filtros" type="fieldset">
            <rkm-form ref="RkmForm" show-legend>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-date-picker
                            range
                            :max-date="additionals.dataAtual"
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            v-model="model.periodo"
                            :start-validations="validations.periodo"
                            :end-validations="validations.periodo"
                        />
                    </rkm-col>
                    <rkm-col cols="2">
                        <rkm-form-select
                            :options="form.preferenciasCampanha"
                            label="Campanhas"
                            text-field="name"
                            value-field="value"
                            v-model="model.campanha"
                        />
                    </rkm-col>
                    <rkm-col cols="2">
                        <rkm-form-select
                            show-default-option
                            default-option-text="TODOS"
                            label="Registro"
                            text-field="name"
                            value-field="value"
                            :disabled="model.campanha == enums.preferenciaCampanha.MOSTRAR_EXCLUSIVAMENTE"
                            :options="form.tiposRegistro"
                            v-model="model.tipoRegistro"
                        />
                    </rkm-col>
                    <rkm-col cols="4">
                        <rkm-form-select
                            show-default-option
                            :options="form.salas"
                            default-option-text="TODAS"
                            label="Sala de vacinação"
                            text-field="nome"
                            value-field="id"
                            v-model="model.salaVacinacao"
                        />
                    </rkm-col>
                    
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="form.vacinas"
                            show-default-option
                            default-option-text="TODAS"
                            label="Vacina"
                            text-field="nome"
                            value-field="id"
                            v-model="model.vacina"
                        />
                    </rkm-col>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="form.doses"
                            show-default-option
                            default-option-text="TODAS"
                            label="Dose"
                            text-field="nome"
                            value-field="id"
                            v-model="model.dose"
                        />
                    </rkm-col>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="form.sexos"
                            show-default-option
                            default-option-text="AMBOS"
                            label="Sexo"
                            text-field="name"
                            value-field="value"
                            v-model="model.sexo"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="form.unidades"
                            show-default-option
                            default-option-text="TODOS"
                            label="Unidade do paciente"
                            text-field="nome"
                            value-field="id"
                            v-model="model.unidade"
                        />
                    </rkm-col>
                    <rkm-col cols="2">
                        <rkm-form-select
                            :options="form.areas"
                            show-default-option
                            default-option-text="TODAS"
                            label="Área - Unidade"
                            text-field="nome"
                            value-field="valor"
                            v-model="model.area"
                        />
                    </rkm-col>
                    <rkm-col cols="2">
                        <rkm-form-select
                            :options="form.microareas"
                            show-default-option
                            default-option-text="TODAS"
                            label="Microárea"
                            text-field="nome"
                            value-field="nome"
                            v-model="model.microarea"
                        />
                    </rkm-col>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="form.classificacoes"
                            show-default-option
                            default-option-text="TODOS"
                            label="Classificação do paciente"
                            text-field="nome"
                            value-field="id"
                            v-model="model.classificacao"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">

                        <rkm-form-group
                            label-for="Faixa Etária Inicial"
                            label="Faixa Etária Inicial"
                            class="mb-0"
                        >
                            <rkm-row>
                                <rkm-col cols="4">
                                    <rkm-form-input
                                        append="Anos"
                                        name="Anos"
                                        v-model="model.faixaEtaria.inicial.anos"
                                        :min="0"
                                        number
                                    />
                                </rkm-col>

                                <rkm-col cols="4">
                                    <rkm-form-input
                                        append="Meses"
                                        name="Meses"
                                        v-model="model.faixaEtaria.inicial.meses"
                                        number
                                    />
                                </rkm-col>

                                <rkm-col cols="4">
                                    <rkm-form-input
                                        append="Dias"
                                        name="Dias"
                                        v-model="model.faixaEtaria.inicial.dias"
                                        :min="0"
                                        number
                                    />
                                </rkm-col>
                            </rkm-row>
                        </rkm-form-group>
                    </rkm-col>

                    <rkm-col cols="4">

                        <rkm-form-group
                            label-for="Faixa Etária Final"
                            label="Faixa Etária Final"
                            class="mb-0"
                        >
                            <rkm-row>
                                <rkm-col cols="4">
                                    <rkm-form-input
                                        append="Anos"
                                        name="Anos"
                                        v-model="model.faixaEtaria.final.anos"
                                        number
                                    />
                                </rkm-col>

                                <rkm-col cols="4">
                                    <rkm-form-input
                                        append="Meses"
                                        name="Meses"
                                        v-model="model.faixaEtaria.final.meses"
                                        number
                                    />
                                </rkm-col>

                                <rkm-col cols="4">
                                    <rkm-form-input
                                        append="Dias"
                                        name="Dias"
                                        v-model="model.faixaEtaria.final.dias"
                                        number
                                    />
                                </rkm-col>
                            </rkm-row>
                        </rkm-form-group>
                    </rkm-col>
                    <rkm-col cols="2">
                        <rkm-form-input
                            label="Prontuário"
                            type="text"
                            uppercase
                            v-model="model.prontuario"
                        >
                        </rkm-form-input>
                    </rkm-col>
                    <rkm-col cols="2">
                        <rkm-button
                            :disabled="form.unidades && (form.unidades.length < 1)"
                            :label="false"
                            color="primary"
                            @click="handleBuscarClick"
                        >
                            Buscar
                        </rkm-button>
                        <rkm-button :label="false" @click="handleLimparClick">Limpar</rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            title="Totais"
            type="fieldset"
            no-margin-top
            v-if="mostraResultado"
            >
            <rkm-row>
                <rkm-col cols="2">
                    Aplicação(s)
                    <rkm-alert color="secondary">
                        <strong> {{ totalizadores.aplicacao }} </strong>
                    </rkm-alert>
                </rkm-col>
                <rkm-col cols="2">
                    Atualização(s)
                    <rkm-alert color="secondary">
                        <strong> {{ totalizadores.atualizacao }} </strong>
                    </rkm-alert>
                </rkm-col>
                <rkm-col cols="2">
                    Paciente(s)
                    <rkm-alert color="secondary">
                        <strong> {{ totalizadores.paciente }} </strong>
                    </rkm-alert>
                </rkm-col>
                <rkm-col cols="2">
                    Unidade(s) do(s) paciente(s)
                    <rkm-alert color="secondary">
                        <strong> {{ totalizadores.unidade }} </strong>
                    </rkm-alert>
                </rkm-col>
                <rkm-col cols="2">
                    Sala(s) de vacinação
                    <rkm-alert color="secondary">
                        <strong> {{ totalizadores.sala }} </strong>
                    </rkm-alert>
                </rkm-col>
                <rkm-col cols="2">
                    Vacina(s)
                    <rkm-alert color="secondary">
                        <strong> {{ totalizadores.vacina }} </strong>
                    </rkm-alert>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area v-if="mostraResultado" no-margin-top title="Resultado">
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="handleTodosClick"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedColumns"
                        value-field="key"
                    />
                </rkm-dropdown>
                <rkm-button
                    :disabled="items.length === 0"
                    @click="handleImprimirClick"
                    color="info"
                    small
                    title="Imprimir"
                    >
                    <rkm-icon icon="print" />
                </rkm-button>
                <rkm-button
                    :disabled="items.length === 0"
                    @click="handleExportarClick"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table :fields="fields" :items="items">
            </rkm-table>
        </rkm-area>
    </div>
    <rkm-alert v-else color="warning">
        A unidade logada não é uma sala de vacinação ou está desativada, favor cadastra-la para acessar o relatório.
    </rkm-alert>
</template>


<script>
// Enums.
import parametrizacaoDescricaoVacina from '@/enums/imunizacao/parametrizacaoDescricaoVacina'
import tipoRegistro from '@/enums/imunizacao/tipoRegistro'
import preferenciaCampanha from '@/enums/imunizacao/preferenciaCampanha'
import sexo from '@/enums/imunizacao/sexo'

// Mixins.
import { error, permissao, formats, object, repository, stringCase, file } from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import { mapActions,mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ lotacao: 'getLotacao' }),
        fields() {
            return this.columns.filter(column => (column.fixed || false) || this.selectedColumns.includes(column.key))
        },
        validations() {
            return {
                periodo: { required: true },
                registro: { disabled: true}
            }
        },
        optionalColumns() {
            return this.columns.filter(column => !(column.fixed || false))
        },
    },
    created() {
        this.repositories = {
            relatorioDeAplicacao: this.getConectaSusRepository('imunizacao.relatorioDeAplicacao'),
            impressao: this.getConectaSusRepository('impressao.imunizacao'),
            exportacao: this.getConectaSusRepository('exportacao.imunizacao'),
        }
    },
    data: () => ({
        indeterminate: true,
        enums: { parametrizacaoDescricaoVacina, tipoRegistro, sexo, preferenciaCampanha },
        model: {
            periodo: {
                start: '',
                end: '',
            },
            tipoRegistro: null,
            salaVacinacao: null,
            vacina: null,
            dose: null,
            sexo: null,
            unidade: null,
            classificacao: null,
            prontuario: null,
            faixaEtaria: {
                inicial: {
                    anos: null,
                    meses: null,
                    dias: null,
                },
                final: {
                    anos: null,
                    meses: null,
                    dias: null,
                },
            },
            area: null,
            microarea: null,
            campanha: preferenciaCampanha.NAO_INCLUIR
        },
        form: {
            tiposRegistro: [
                { name: 'Aplicação', value: tipoRegistro.APLICACAO },
                { name: 'Atualização', value: tipoRegistro.ATUALIZACAO },
            ],
            sexos: [
                { name: 'Masculino', value: sexo.MASCULINO },
                { name: 'Feminino', value: sexo.FEMININO },
            ],
            preferenciasCampanha: [
                { name: 'Não incluir campanhas', value: preferenciaCampanha.NAO_INCLUIR },
                { name: 'Incluir campanhas', value: preferenciaCampanha.INCLUIR },
                { name: 'Exibir apenas campanhas', value: preferenciaCampanha.MOSTRAR_EXCLUSIVAMENTE },
            ],
            salas: null,
            vacinas: null,
            doses: null,
            unidades: {},
            classificacoes: null,
            equipes: null,
            areas: null,
            microareas: null,

        },
        others: {moment},
        items: [],
        columns: [
            {
                key: "data",
                label: "Data",
                sortable: true,
                fixed: true,
            },
            {
                key: "paciente",
                label: "Paciente",
                sortable: true,
                fixed: true,
            },
            {
                key: "idade",
                label: "Idade",
                sortable: true,
                fixed: true,
            },
            {
                key: "sexo",
                label: "Sexo",
                sortable: true,
                fixed: true,
            },
            {
                key: "cpf",
                label: "CPF",
                sortable: true,
                fixed: false,
            },
            {
                key: "cns",
                label: "CNS",
                sortable: true,
                fixed: false,
            },
            {
                key: "unidade",
                label: "Unidade do Paciente",
                sortable: true,
                fixed: false,
            },
            {
                key: "classificacao",
                label: "Classificação",
                sortable: true,
                fixed: false,
            },
            {
                key: "prontuario",
                label: "Prontuário",
                sortable: true,
                fixed: true,
            },
            {
                key: "area",
                label: "Área - Unidade",
                sortable: true,
                fixed: false,
            },
            {
                key: "microarea",
                label: "Microárea",
                sortable: true,
                fixed: false,
            },
            {
                key: "agente",
                label: "Agente Comunitário Responsável",
                sortable: true,
                fixed: false,
            },
            {
                key: "sala",
                label: "Sala de Vacinação",
                sortable: true,
                fixed: true,
            },
            {
                key: "vacina",
                label: "Vacina",
                sortable: true,
                fixed: true,
            },
            {
                key: "lote",
                label: "Lote",
                sortable: true,
                fixed: true,
            },
            {
                key: "validade",
                label: "Validade do Lote",
                sortable: true,
                fixed: true,
            },
            {
                key: "dose",
                label: "Dose",
                sortable: true,
                fixed: true,
            },
            {
                key: "registro",
                label: "Registro",
                sortable: true,
                fixed: true,
            },
            {
                key: "estrategia",
                label: "Estratégia",
                sortable: true,
                fixed: true,
            },
            {
                key: "campanha",
                label: "Campanha",
                sortable: true,
                fixed: false,
            },
        ],
        mostraResultado: false,
        totalizadores: {
            aplicacao: 0,
            atualizacao: 0,
            paciente: 0,
            unidade: 0,
            sala: 0,
            vacina: 0,
        },
        selectedAll: false,
        selectedColumns: [],
        additionals: {
            salaVacinacaoLogada: false,
            dataAtual: null,
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioDeAplicacao.index()
                .then(response => {
                    this.additionals.salaVacinacaoLogada = response.data && response.data.salaVacinacao && response.data.salaVacinacao.id;
                    this.additionals.dataAtual = response.data.dataAtual;
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())

        },
        request() {
            const model = this.clone(this.model)

            model.periodo.start = this.others.moment(model.periodo.start).format('DD/MM/YYYY')
            model.periodo.end = this.others.moment(model.periodo.end).format('DD/MM/YYYY')

            return model
        },
        getSalaVacinacao() {
            this.setLoading();

            const request = {
                listar: 'salaVacinacao',
                ...this.request(),
            }

            this.repositories.relatorioDeAplicacao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(({data}) => {
                    this.form.salas = data;
                })
                .catch(this.handleError)
                .finally(() => {
                    this.unsetLoading();
                })
        },
        getVacinas() {
            this.setLoading();

            const request = {
                listar: 'vacina',
                ...this.request(),
            }

            this.repositories.relatorioDeAplicacao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(({data}) => {
                    this.form.vacinas = data;
                    this.getDoses();
                })
                .catch(this.handleError)
                .finally(() => {
                    this.unsetLoading();
                })
        },
        getDoses() {
            this.setLoading();

            const request = {
                listar: 'dose',
                'vacinas': this.form.vacinas.map(vacina => vacina.id).join(', '),
                ...this.request(),
            }

            this.repositories.relatorioDeAplicacao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(({data}) => {
                    this.form.doses = data;
                })
                .catch(this.handleError)
                .finally(() => {
                    this.unsetLoading();
                })
        },
        getUnidades() {
            this.setLoading();

            const request = {
                listar: 'unidade',
                ...this.request(),
            }

            this.repositories.relatorioDeAplicacao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(({data}) => {
                    this.form.unidades = data;
                })
                .catch(this.handleError)
                .finally(() => {
                    this.unsetLoading();
                })
        },
        getEquipes(){
            this.setLoading();

            const request = {
                listar: 'equipe',
                ...this.request(),
            }

            this.repositories.relatorioDeAplicacao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(({data}) => {
                    this.form.areas = data.map(equipe => equipe.area)
                    this.form.microareas = data.map(equipe => equipe.microarea).filter(
                        (value, index, current_value) => current_value.indexOf(value) === index
                    );
                })
                .catch(this.handleError)
                .finally(() => {
                    this.unsetLoading();
                })
        },
        getClassificacoes() {
            this.setLoading();

            const request = {
                listar: 'classificacao',
                ...this.request(),
            }

            this.repositories.relatorioDeAplicacao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(({data}) => {
                    this.form.classificacoes = data;
                })
                .catch(this.handleError)
                .finally(() => {
                    this.unsetLoading();
                })
        },
        handleBuscarClick() {
            this.$refs.RkmForm.validate()
            .then(valid => {
                if (valid === false) return

                this.setLoading()
    
                this.repositories.relatorioDeAplicacao.search(this.camelObjectKeysToSnakeRecursive(this.request()))
                    .then(({data}) => {
                        this.items = data.registros;
                        this.totalizadores = data.totalizadores;
                        this.mostraResultado = true;

                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            })

        
        },
        handleLimparClick() {
            this.mostraResultado = false;
            this.model.periodo.start = null;
            this.model.periodo.end = null;
            this.model.campanha = this.enums.preferenciaCampanha.NAO_INCLUIR;
            this.model.tipoRegistro = null;
            this.model.salaVacinacao = null;
            this.model.vacina = null;
            this.model.dose = null;
            this.model.sexo = null;
            this.model.unidade = null;
            this.model.area = null;
            this.model.microarea = null;
            this.model.classificacao = null;
            this.model.faixaEtaria.inicial.anos = null;
            this.model.faixaEtaria.inicial.meses = null;
            this.model.faixaEtaria.inicial.dias = null;
            this.model.faixaEtaria.final.anos = null;
            this.model.faixaEtaria.final.meses = null;
            this.model.faixaEtaria.final.dias = null;
            this.model.prontuario = null;
            
        },
        handleTodosClick(selected) {
            this.selectedColumns = selected ? this.optionalColumns.map(c => c.key) : []
        },
        handleImprimirClick() {
            this.setLoading()

            const request = {
                ...this.request(),
                selectedColumns: this.fields.map(field => ({
                    class: field.class,
                    key: this.camelToSnake(field.key),
                    label: field.label,
                })),
            }

            this.repositories.impressao.relatorioDeAplicacao(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        handleExportarClick() {
            this.setLoading()

            const request = {
                ...this.request(),
                selectedColumns: this.fields.map(field => ({
                    class: field.class,
                    key: this.camelToSnake(field.key),
                    label: field.label,
                })),
            }

            this.repositories.exportacao.relatorioDeAplicacao(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [ error, permissao, formats, object, repository, stringCase, file ],
    mounted() {
        this.load()
    },
    watch: {
        'model': {
            deep: true,
            handler() {
                this.mostraResultado = false;
            },
        },
        'model.periodo': {
            deep: true,
            handler(value) {
                if (value.start && value.end) {
                    Promise.all([
                        this.getSalaVacinacao(),
                        this.getVacinas(),
                        this.getUnidades(),
                        this.getEquipes(),
                        this.getClassificacoes(),
                    ]);
                }
            },
        },
        'model.campanha': {
            deep: true,
            handler() {
                if(this.model.periodo.start && this.model.periodo.start) {
                    Promise.all([
                        this.getSalaVacinacao(),
                        this.getVacinas(),
                        this.getUnidades(),
                        this.getEquipes(),
                        this.getClassificacoes(),
                    ]);
                }
            },
        },
        'model.tipoRegistro': {
            deep: true,
            handler() {
                if(this.model.periodo.start && this.model.periodo.start) {
                    Promise.all([
                        this.getSalaVacinacao(),
                        this.getVacinas(),
                        this.getUnidades(),
                        this.getEquipes(),
                        this.getClassificacoes(),
                    ]);
                }
            },
        },
        'model.salaVacinacao': {
            deep: true,
            handler() {
                Promise.all([
                    this.getVacinas(),
                    this.getUnidades(),
                    this.getEquipes(),
                    this.getClassificacoes(),
                ]);
            },
        },
        'model.vacina': {
            deep: true,
            handler() {
                Promise.all([
                    this.getDoses(),
                    this.getUnidades(),
                    this.getEquipes(),
                    this.getClassificacoes(),
                ]);
            },
        },
        'model.dose': {
            deep: true,
            handler() {
                Promise.all([
                    this.getUnidades(),
                    this.getEquipes(),
                    this.getClassificacoes(),
                ]);
            },
        },
        'model.faixaEtaria': {
            deep: true,
            handler(faixa) {
                if((faixa.inicial.meses && faixa.inicial.meses > 11)){
                    faixa.inicial.meses = 11;
                }
                if((faixa.inicial.dias && faixa.inicial.dias > 31)){
                    faixa.inicial.dias = 31;
                }
                if((faixa.final.meses && faixa.final.meses > 11)){
                    faixa.final.meses = 11;
                }
                if((faixa.final.dias && faixa.final.dias > 31)){
                    faixa.final.dias = 31;
                }
            },
        },
        selectedColumns(value) {
            this.indeterminate = value.length > 0 && value.length != this.optionalColumns.length
            this.selectedAll = value.length > 0 && value.length == this.optionalColumns.length
        },
    },
}
</script>
